<template lang="pug">
.settings-option
	bunt-input(name="optionText", label="Option Text", v-model="optionText")
	bunt-input.option-value(name="optionValue", label="Option Value (JSON)", v-model="optionValue", :validation="$v.invalidOptionValue")
</template>
<script>
import { json } from 'lib/validators'
export default {
	props: {
		option: Object,
		index: Number
	},
	data () {
		return {
			invalidOptionValue: null
		}
	},
	validations: {
		invalidOptionValue: {
			json: json('invalid json')
		}
	},
	computed: {
		optionText: {
			get () {
				return this.option.text
			},
			set (value) {
				this.$store.dispatch('updateOption', {
					option: this.option,
					update: {
						text: value
					}
				})
			}
		},
		optionValue: {
			get () {
				return this.invalidOptionValue || JSON.stringify(this.option.value)
			},
			set (value) {
				try {
					this.$store.dispatch('updateOption', {
						option: this.option,
						update: {
							value: JSON.parse(value)
						}
					})
					this.invalidOptionValue = null
				} catch (e) {
					console.warn(e, value)
					this.invalidOptionValue = value
				}
			}
		}
	},
	created () {},
	mounted () {
		this.$nextTick(() => {
		})
	},
	methods: {
	}
}
</script>
<style lang="stylus">
@import '~settings'

.node-settings .settings-option
	padding: 8px 0 0 0
	&:not(:first-child)
		border-top: border-separator()
	.option-value
		height: 56px
</style>
